import { createFileRoute, redirect } from '@tanstack/react-router'

import { MENU } from '@/constants/common/message.constants'
import { getDefaultUserMeTenant } from '@/features/auth/models'
import { USER_TYPE } from '@/libs/api/types'

export const Route = createFileRoute(
  '/_protected/$tenantKey/settings/partners/create'
)({
  meta: () => [{ title: MENU.REGISTERING_PARTNER }],
  beforeLoad: ({ context: { auth } }) => {
    if (auth?.user?.type !== USER_TYPE.OWNER) {
      // DCユーザー以外の場合はパートナー一覧にリダイレクト
      throw redirect({
        to: `/${getDefaultUserMeTenant(auth.user).key}/settings/partners`
      })
    }
  }
})
